import React, { useEffect, useRef, useState } from "react";
import { Calendar, MoreVertical } from "lucide-react";

interface PropertyReturnCardMenuProps {
  onUpdatePurchaseDate: () => void;
}

export default function PropertyReturnCardMenu({
  onUpdatePurchaseDate,
}: PropertyReturnCardMenuProps) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  const handleUpdatePurchaseDate = () => {
    setIsOpen(false);
    onUpdatePurchaseDate();
  };

  return (
    <div className="relative shrink-0" ref={menuRef}>
      <button
        type="button"
        onClick={() => setIsOpen((previous) => !previous)}
        className="inline-flex items-center justify-center rounded-full p-1.5 text-[#8b949e] transition-colors hover:bg-white/[0.06] hover:text-[#f0f6fc]"
        aria-label="Ações do imóvel"
        aria-expanded={isOpen}
        aria-haspopup="menu"
      >
        <MoreVertical className="h-4 w-4" />
      </button>

      {isOpen && (
        <div
          role="menu"
          className="absolute right-0 top-full z-20 mt-1 min-w-[15rem] overflow-hidden rounded-xl border border-white/[0.08] bg-[#161b22] py-1 shadow-[0_8px_24px_rgba(0,0,0,0.35)]"
        >
          <button
            type="button"
            role="menuitem"
            onClick={handleUpdatePurchaseDate}
            className="flex w-full items-center gap-2 px-3 py-2.5 text-left text-sm text-[#f0f6fc] transition-colors hover:bg-white/[0.06]"
          >
            <Calendar className="h-4 w-4 shrink-0 text-[#6ea8ff]" />
            Atualizar dados do imóvel
          </button>
        </div>
      )}
    </div>
  );
}
